import React, { Fragment, useRef, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import { KeyboardDatePicker } from '@material-ui/pickers'
import {
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core'

import * as service from 'service'

const SummaryFormItems = ({
  disabled = false,
  index,
  name,
  planAction,
  componentIndex,
}) => {
  const [options, setOptions] = useState([])
  const [loadingOptions, setLoadingOptions] = useState(false)

  const requestIdRef = useRef(0)

  const { control, errors, setValue, watch } = useFormContext()

  const componentError = errors?.evidencePlanActions?.[componentIndex]

  const responsibleValue = watch(`${name}.planActions.${index}.responsible`)

  const handleInputChange = async (_, inputValue) => {
    if (!inputValue || inputValue.length < 3) return

    const currentId = ++requestIdRef.current
    setLoadingOptions(true)
    try {
      const response = await service.dponet.users.get({
        name: inputValue,
        perPage: 10000000,
        minimal: true,
        order: 'name ASC',
      })
      if (currentId === requestIdRef.current) {
        setOptions(response?.data?.users || [])
      }
    } catch {
      if (currentId === requestIdRef.current) {
        setOptions([])
      }
    } finally {
      if (currentId === requestIdRef.current) {
        setLoadingOptions(false)
      }
    }
  }

  return (
    <Fragment>
      <Controller
        as={<Fragment />}
        name={`${name}.planActions.${index}.originId`}
        control={control}
      />
      <Controller
        as={<Fragment />}
        name={`${name}.planActions.${index}.status`}
        control={control}
      />
      <Controller
        as={<Fragment />}
        name={`${name}.planActions.${index}.responsible`}
        control={control}
        defaultValue={planAction?.responsible || null}
      />
      <Grid item xs={12} md={6}>
        <Typography variant="h5" gutterBottom>
          Responsável *
        </Typography>
        <Autocomplete
          options={options}
          getOptionLabel={(option) => option?.name || ''}
          getOptionSelected={(option, value) =>
            option?.id === value?.id || value?.id === 0
          }
          disabled={disabled}
          value={responsibleValue || null}
          onChange={(_, value) =>
            setValue(`${name}.planActions.${index}.responsible`, value, {
              shouldValidate: true,
            })
          }
          onInputChange={handleInputChange}
          noOptionsText={
            loadingOptions ? 'Carregando...' : 'Digite no mínimo 3 letras'
          }
          loading={loadingOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              error={!!componentError?.planActions?.[index]?.responsible}
              helperText={
                componentError?.planActions?.[index]?.responsible?.message
              }
              disabled={disabled}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingOptions ? (
                      <CircularProgress color="primary" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="h5" gutterBottom>
          Prazo *
        </Typography>
        <Controller
          as={
            <KeyboardDatePicker
              inputVariant="outlined"
              format="DD/MM/yyyy"
              error={!!componentError?.planActions?.[index]?.deadlineDate}
              helperText={
                componentError?.planActions?.[index]?.deadlineDate?.message
              }
              onChange={(newValue) => ({ value: newValue })}
              disabled={disabled}
              fullWidth
            />
          }
          control={control}
          name={`${name}.planActions.${index}.deadlineDate`}
          mode="onChange"
          defaultValue={planAction?.deadlineDate || null}
        />
      </Grid>
    </Fragment>
  )
}

SummaryFormItems.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  planAction: PropTypes.object,
  componentIndex: PropTypes.number.isRequired,
}

export default SummaryFormItems
